import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  _idContactoSocio: Yup.string().required(),
  _idDireccionSocio: Yup.string().required(),
  _idSocio: Yup.string().required(),
  condicionPago: Yup.string().required(),
  fechaEmision: Yup.string().required(),
  fechaEntrega: Yup.string().required(),
  glosa: Yup.string().required(),
  medioPago: Yup.string().required(),
  moneda: Yup.string().required(),
  tipo: Yup.string().required()
})
